import { useEffect, useState } from "react";
import "./ConferenceRegistrationForm.css";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import serverConfig from "../config";
import toast, { Toaster } from "react-hot-toast";

const iconSend = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-send-check"
    viewBox="0 0 20 20"
  >
    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372zm-2.54 1.183L5.93 9.363 1.591 6.602z" />
    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686" />
  </svg>
);

export default function SchoolRegistration({
  name_school,
  year_school,
}) {
  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    email: "",
    telefono: "",
    istituzione: "",
    cap: "",
    citta: "",
    indirizzo: "",
    tassa: "",
    richieste: "",
    privacyConsent: "",
  });

  const [listFee, setListFee] = useState(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null); // token generato da reCAPTCHA
  const [siteKey, setSiteKey] = useState(null); // site key da back-end
  const [isVerified, setIsVerified] = useState(false); // per disabilitare submit

  const [waitForResponseSend, setWaitForResponseSend] = useState(false);
  //const [responseSendInfo, setResponseSendInfo] = useState(null);
  const [responseSendInfo, setResponseSendInfo] = useState({
    status: null,
    message: "waiting",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name == "tassa" ? value : value.toUpperCase(),
    }));
  };

  // Quando il CAPTCHA viene completato
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    setIsVerified(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      toast.error("Completa il reCAPTCHA!");
      return;
    }

    setWaitForResponseSend(true);

    try {
      const response = await axios.post(
        `${serverConfig.serverUrl}/verify_recaptcha_school`,
        {
          recaptchaResponse: recaptchaToken,
          year_school: year_school,
          name_school: name_school,
          formData: formData,
        }
      );

      const status = response.data.success;
      const message = response.data.message || "Risposta dal server";

      setResponseSendInfo({ status, message });

      if (status) {
        toast.success("Registrazione completata con successo!");
        setFormData({
          nome: "",
          cognome: "",
          email: "",
          telefono: "",
          istituzione: "",
          cap: "",
          citta: "",
          indirizzo: "",
          tassa: "",
          richieste: "",
          privacyConsent: "",
        });
      } else {
        toast.error(message);
        setResponseSendInfo({ status: false, message: message });
      }
    } catch (err) {
      toast.error("Errore nella comunicazione col server");
      setResponseSendInfo({ status: false, message: "Errore di connessione" });
    }

    setTimeout(() => {
      setWaitForResponseSend(false);
      setResponseSendInfo({ status: null, message: "waiting" });
    }, 5000);
  };

  const clearForm = () =>
    setFormData({
      nome: "",
      cognome: "",
      email: "",
      telefono: "",
      istituzione: "",
      cap: "",
      citta: "",
      indirizzo: "",
      tassa: "",
      richieste: "",
      privacyConsent: "",
    });

  const contentResponseSend = ({ status, message }) => {
    let style = {
      marginTop: "15px",
      padding: "10px",
      borderRadius: "5px",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
    };

    let icon = null;

    if (status === null) {
      style = {
        ...style,
        backgroundColor: "#e2e3e5",
        color: "#383d41",
        border: "1px solid #d6d8db",
      };
      icon = <span className="spinner" />;
    } else if (status === true) {
      style = {
        ...style,
        backgroundColor: "#d4edda",
        color: "#155724",
        border: "1px solid #c3e6cb",
      };
      icon = <span className="check-icon" />;
    } else if (status === false) {
      style = {
        ...style,
        backgroundColor: "#f8d7da",
        color: "#721c24",
        border: "1px solid #f5c6cb",
      };
      icon = <span className="cross-icon" />;
    }

    return (
      <div style={style}>
        {icon}
        <span>{message}</span>
      </div>
    );
  };

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_code_recaptcha`)
      .then((res) => setSiteKey(res.data.siteKey))
      .catch(() => toast.error("Errore nel recupero dei dati"));
  }, []);

  useEffect(() => {
    if (year_school && name_school) {
      axios
        .post(`${serverConfig.serverUrl}/get_type_fee_school`, {
          year_school: year_school,
          name_school: name_school,
        })
        .then((res) => setListFee(res.data))
        .catch(() => toast.error("Errore nel recupero dei dati"));
    }
  }, [year_school, name_school]);

  return (
    <>
      <div style={{ padding: "20px" }}>
        <Toaster />
        <button
          onClick={clearForm}
          style={{
            borderRadius: "10px",
            padding: "10px",
            color: "#F5F7FA",
            backgroundColor: "#003366",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            class="bi bi-stars"
            viewBox="0 0 16 16"
          >
            <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" />
          </svg>
          RIPULISCI FORM
        </button>
        {waitForResponseSend ? (
          contentResponseSend(responseSendInfo)
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ textAlign: "center" }}>
              <h3>REGISTRAZIONE</h3>
            </div>
            {[
              { label: "Nome *", name: "nome", type: "text", required: true },
              {
                label: "Cognome *",
                name: "cognome",
                type: "text",
                required: true,
              },
              {
                label: "Email *",
                name: "email",
                type: "email",
                required: true,
                pattern: "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                placeholder: "es. mario.rossi@email.com",
              },
              {
                label: "Numero di Telefono",
                name: "telefono",
                type: "tel",
                required: false,
              },
              {
                label: "Istituzione *",
                name: "istituzione",
                type: "text",
                required: true,
              },
              {
                label: "Codice Postale *",
                name: "cap",
                type: "text",
                required: true,
              },
              { label: "Città *", name: "citta", type: "text", required: true },
              {
                label: "Indirizzo",
                name: "indirizzo",
                type: "text",
                required: false,
              },
            ].map(({ label, name, type, required, pattern, placeholder }) => (
              <div className="row">
                <div key={name} className="input-group">
                  <label>{label}</label>
                  <input
                    type={type}
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    required={required}
                    pattern={pattern}
                    placeholder={placeholder}
                  />
                </div>
              </div>
            ))}

            {listFee && (
              <div className="input-group">
                <label>Tassa di Iscrizione *</label>
                <select
                  name="tassa"
                  value={formData.tassa}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Seleziona una tassa
                  </option>

                  {listFee
                    .sort((a, b) => a.order - b.order)
                    .map((fee, index) => (
                      <option
                        key={index}
                        value={`${fee.who}: ${fee.cost}`}
                        //disabled={(fee.selectable)}
                      >
                        {fee.who}: {fee.cost}€
                      </option>
                    ))}
                </select>
              </div>
            )}
            <div className="input-group">
              <label>Richieste Speciali</label>
              <textarea
                name="richieste"
                rows="3"
                value={formData.richieste}
                onChange={handleChange}
                placeholder="Es. intolleranze alimentari, accessibilità, ecc."
              />
            </div>
            <div className="input-group">
              <label>
                Informativa ai sensi del D. Lgs. 30 giugno 2003, n. 196:
              </label>
              <select
                name="privacyConsent"
                value={
                  formData.privacyConsent === true
                    ? "true"
                    : formData.privacyConsent === false
                    ? "false"
                    : ""
                }
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    privacyConsent: e.target.value === "true",
                  }))
                }
                required
              >
                <option value="" disabled>
                  Seleziona un'opzione
                </option>
                <option value="true">
                  Autorizzo al trattamento dei dati personali da me forniti per
                  la distribuzione a Aziende coinvolte nell'attività
                  congressuale.
                </option>
                <option value="false">
                  Non autorizzo al trattamento dei dati personali da me forniti
                  per la distribuzione a Aziende coinvolte nell'attività
                  congressuale.
                </option>
              </select>
            </div>

            {siteKey && (
              <div style={{ margin: "15px 0" }}>
                <ReCAPTCHA sitekey={siteKey} onChange={handleRecaptchaChange} />
              </div>
            )}
            <div style={{ textAlign: "center" }}>
              <button
                type="submit"
                disabled={!isVerified}
                style={{
                  borderRadius: "10px",
                  padding: "10px",
                  color: "#F5F7FA",
                  backgroundColor: "#003366",
                }}
              >
                {iconSend} INVIA REGISTRAZIONE
              </button>
            </div>
          </form>
        )}
      </div>
    </>
  );
}
